import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import HeaderSecondary from '@components/HeaderSecondary';

import { stateClear } from './action';
import AuthMobileNumberPage from './AuthMobileNumberPage';
import AuthOtpCodePage from './AuthOtpCodePage';
import OtpTokenPage from './OtpTokenPage';
import AuthPasswordPage from './AuthPasswordPage';
import AuthMemberIdPage from './AuthMemberIdPage';

const AuthRoute = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(stateClear());
    return () => {
      dispatch(stateClear());
    };
  }, [location.pathname]);

  return (
    <>
      <HeaderSecondary />
      <Container className="mt-4">
        <Row>
          <Col md={{ span: 6, offset: 3 }}>
            <Routes>
              <Route index element={<AuthMobileNumberPage />} />
              <Route path="otp-code/:mobileNumber" element={<AuthOtpCodePage />} />
              <Route path="otp-link/:otpToken" element={<OtpTokenPage />} />
              <Route path="password/:mobileNumber" element={<AuthPasswordPage />} />
              <Route path="member-id" element={<AuthMemberIdPage />} />
              <Route path="*" element={<Navigate to="" />} />
            </Routes>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export { AuthRoute };
